/**
 * OverdueInvoicesBanner Component - T133
 *
 * Sprint 006 D3: speist sich aus /dashboard/metrics statt aus einer
 * client-summierten Rechnungsliste (limit 100). Damit zeigen Banner und
 * Überfällig-MetricCard dieselbe Zahl aus derselben Server-Aggregation —
 * vorher widersprachen sich beide („13 überfällig / −10.786 €" neben
 * „Überfällig 0,00 €").
 */
import { Link } from '@tanstack/react-router';
import { useDashboardMetrics } from '../../hooks/useDashboard';
import { formatCurrency } from '@armard/shared';

export function OverdueInvoicesBanner() {
  const { data } = useDashboardMetrics();

  if (!data || data.overdueCount === 0) {
    return null;
  }

  return (
    <div className="bg-red-500/10 backdrop-blur-sm border border-red-500/20 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-red-500/20 rounded-full">
            <svg
              className="w-5 h-5 text-red-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div>
            <p className="text-red-400 font-medium">
              {data.overdueCount}{' '}
              {data.overdueCount === 1 ? 'Rechnung überfällig' : 'Rechnungen überfällig'}
            </p>
            <p className="text-sm text-red-400/70 tabular-nums">
              Gesamtbetrag: {formatCurrency(data.overdueBalance)}
            </p>
          </div>
        </div>
        <Link
          to="/invoices"
          search={{ status: 'overdue' }}
          className="text-sm text-red-400 hover:text-red-300 transition-colors"
        >
          Anzeigen →
        </Link>
      </div>
    </div>
  );
}
